import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../typography'
import ShareOnFacebook from './facebook'
import ShareOnTwitter from './twitter'
import ShareOnLinkedin from './linkedin'
import CopyToClipboard from './clipboard'

const Share = ({ size = 32, url, extended, horizontal, light, ...attrs }) => {
  attrs.className = classNames(
    attrs.className,
    [
      'bg-white',
      'p-6',
      'w-screen'
    ]
  )
  attrs.style = {
    ...(attrs.style || {}),
    maxWidth: '20rem'
  }

  return <div
    {...attrs}
    onClick={(e) => { e.stopPropagation() }} >
    <Typography
      size={'five'}
      weight={'black'}>
      Comparitr
    </Typography>

    <ShareOnFacebook url={url} className={'mt-4'} />
    <ShareOnTwitter url={url} className={'mt-4'} />
    <ShareOnLinkedin url={url} className={'mt-4'} />
    <CopyToClipboard url={url} className={'mt-4'} />
  </div>
}

Share.propTypes = {
  size: PropTypes.number,
  url: PropTypes.string,
  appId: PropTypes.string,
  extended: PropTypes.bool,
  horizontal: PropTypes.bool,
  light: PropTypes.bool,
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.element, PropTypes.func])
}

export default Share
